import type { RootState } from '~/src/redux/store';
import type { PopupInterface } from './popups.types';

export const selectPopupsStack = (state: RootState): PopupInterface[] => state.popups.popupStack;
